.carouselContainer {
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 60vh;
}

.carouselWrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background-color: var(--grays-light);
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);
}

.carouselTrack {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.3s ease-in-out;
}

.imageItem {
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  position: relative;
}

.imageItem img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: opacity 0.2s ease-in-out;
  max-height: 60vh;
}

.overlayContent {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 2;
}

/* Ensure overlay children can receive pointer events if needed */
.overlayContent > * {
  pointer-events: auto;
}

@media all and (--reefer-media-tablet-min) {
  .imageItem img {
    max-height: unset;
    object-fit: cover;
  }

  .carouselContainer {
    max-height: unset;
  }

  .carouselWrapper {
    border-radius: 16px;
  }
}
